import { themes } from "mdx-deck"

export default {
  ...themes.future,
  ...themes.prism,
}
